/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LearnWorldCourseDetailModel } from '../../models/learn-world-course-detail-model';

export interface LearnWorldCoursesCourseIdGet$Params {
  courseId: string;
}

export function learnWorldCoursesCourseIdGet(http: HttpClient, rootUrl: string, params: LearnWorldCoursesCourseIdGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<LearnWorldCourseDetailModel>> {
  const rb = new RequestBuilder(rootUrl, learnWorldCoursesCourseIdGet.PATH, 'get');
  if (params) {
    rb.path('courseId', params.courseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<LearnWorldCourseDetailModel>;
    })
  );
}

learnWorldCoursesCourseIdGet.PATH = '/LearnWorld/Courses/{courseId}';
